import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter signup:', email);
    setEmail('');
  };

  return (
    <footer className="bg-zinc-800 text-white px-8 md:px-16 lg:px-24 py-16">
      <div className="max-w-7xl mx-auto">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-16 pb-12 border-b border-gray-600">
          <div className="flex items-center gap-3 mb-4 md:mb-0">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-orange-500">
              <i className="ri-home-smile-2-line text-2xl text-white"></i>
            </div>
            <span className="text-2xl font-bold whitespace-nowrap" style={{ fontFamily: 'Inter, sans-serif' }}>
              ReloExpert
            </span>
          </div>
          <p className="text-gray-400 text-base">
            Simplifying corporate relocations since 2010
          </p>
        </div>

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Services Column */}
          <div>
            <h4 className="text-lg font-semibold text-gray-300 mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  Executive Relocation
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  Group Moves
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  Destination Services
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  Expense Management
                </a>
              </li>
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h4 className="text-lg font-semibold text-gray-300 mb-6">Resources</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  Relocation Guide
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  City Profiles
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  Cost Calculator
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  Blog & Insights
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-lg font-semibold text-gray-300 mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  Our Team
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  Careers
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-base">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-lg font-semibold text-gray-300 mb-6">Stay Updated</h4>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              Subscribe to our newsletter for relocation tips and industry insights
            </p>
            <form onSubmit={handleSubmit} className="flex gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded-lg bg-zinc-700 border border-zinc-600 text-white placeholder-gray-400 focus:outline-none focus:border-orange-500 text-sm"
                required
              />
              <button
                type="submit"
                className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg transition-colors flex items-center gap-2 whitespace-nowrap"
              >
                <span className="hidden sm:inline text-sm font-medium">Subscribe</span>
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-gray-600">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Copyright */}
            <div className="text-center md:text-left">
              <p className="text-white text-lg mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>
                © 2025 ReloExpert
              </p>
              <p className="text-gray-400 text-sm">All Rights Reserved</p>
            </div>

            {/* Tagline */}
            <div className="text-center">
              <p className="text-white text-2xl leading-relaxed" style={{ fontFamily: 'Playfair Display, serif' }}>
                Your trusted partner in corporate mobility solutions
              </p>
            </div>

            {/* Social Links */}
            <div className="flex gap-6">
              <a href="#" className="text-blue-400 hover:text-blue-300 transition-colors text-sm underline whitespace-nowrap">
                LinkedIn
              </a>
              <a href="#" className="text-blue-400 hover:text-blue-300 transition-colors text-sm underline whitespace-nowrap">
                Twitter
              </a>
              <a href="#" className="text-blue-400 hover:text-blue-300 transition-colors text-sm underline whitespace-nowrap">
                Facebook
              </a>
            </div>
          </div>

          {/* Quick Link */}
          <div className="text-center mt-8">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-orange-400 transition-colors text-sm"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
